import { useTranslate } from 'hooks/useTranslate';

import { getLocalizedValue, Localized } from 'utils/getLocalizedValue';

import { folderContentIcons } from 'modules/dashboard/constants/foldersContentType';

import './DashboardFolderContentItem.scss';

type DashboardFolderContentItemProps = {
  index: number;
  title: Localized;
  type: string;
  url?: string;
};

type DashboardContentItemTypes =
  | 'LINK'
  | 'PDF_LINK'
  | 'VIDEO_LINK'
  | 'PDF_EMBEDDED'
  | 'VIDEO_EMBEDDED';

const DashboardFolderContentItem = (
  folderContent: DashboardFolderContentItemProps
) => {
  const { i18n } = useTranslate();
  const { index, title, type } = folderContent;

  const itemTitle = getLocalizedValue(title, i18n.language);

  return (
    <div
      key={String(index)}
      className="nk-file-item nk-file cursor-pointer w-100 mx-0 pld-content-item"
    >
      <div className="nk-file-info">
        <div className="nk-file-icon">
          <span className="nk-file-content-type">
            <em
              className={`icon ${
                folderContentIcons[type as DashboardContentItemTypes]
              }`}
            />
          </span>
        </div>
        <div className="nk-file-name">
          <div className="nk-file-name-text">
            <span className="title">{itemTitle}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardFolderContentItem;
